import React from 'react';
import { IUser } from '../../../@types';

import OfferCard from '../OfferCard';

import './OffersList.scss';
import { isOdd } from '../../../utils/helpers/math';
import { IOfferCardProps } from '../OfferCard/OfferCard';
import { IJSONParagraph } from '../../../utils/helpers/jsonParagraphs';

export interface IOffersListProps {
  user: IUser | null;
  topOffers: any;
  headerTitle: string;
  headerDescription: IJSONParagraph[];
  headerImageUrl: string;
}

const OffersList = ({
  topOffers,
  headerTitle,
  headerDescription,
  headerImageUrl,
}: IOffersListProps) => {
  const defaultHeaderOffer: IOfferCardProps = {
    title: headerTitle,
    image: { url: headerImageUrl },
    description: headerDescription,
  };
  return (
    <section className="offers-list">
      <div className="offers-list__offer-container">
        <OfferCard
          {...defaultHeaderOffer}
          imagePosition="right"
          division="equal"
        />
        {topOffers.map((topOffer, i) => {
          console.log('topOffer: ', topOffer);
          const { documentId, ...offer } = topOffer;
          return (
            <React.Fragment key={documentId}>
              <OfferCard
                slug={offer.slug}
                title={offer.offerCard.title}
                image={offer.offerCard.image}
                description={offer.offerCard.description}
                ctaUrl={offer.offerCard.ctaUrl}
                imagePosition={isOdd(i) ? 'left' : 'right'}
                division='imagePriority'
                // division='equal'
              />
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
};

export default OffersList;
